<template>
  <div class="teachingblot">
    <div class="blottop">
      <div>教官心得</div>
      <div @click="moreBlog(1)">
        <span>更多</span>
        <i class="el-icon-caret-right"></i>
      </div>
    </div>
    <div v-for="(item,index) in blotData" :key="index">
      <div class="blota">
        <div :class="[{'oneLable':index === 0},{'twoLable':index === 1},{'threeLable':index === 2}]">{{ index + 1 }}</div>
        <div :title="item.title" @click="gotoBlogOne(item.id)">{{item.title ? item.title : '无标题'}}</div>
        <div></div>
      </div>
    </div>
    <div v-if="blotData.length === 0" class="noDataBox">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
import * as teacherInfo from '@/api/teacher/teacherInfo';
export default {
  data() {
    return {
      blotData: [],
    };
  },
  created() {
    this.GetBlogList();
  },
  methods: {
    GetBlogList() {
      let para = {
        type: 1,
        top: 6,
      };
      teacherInfo.GetBlogList(para).then((res) => {
        this.blotData = res.result;
      });
    },
    moreBlog(val) {
      this.$router.push({
        path: '/diaoa/blogList',
        query: {
          type: val,
        },
      });
    },
    gotoBlogOne(id) {
      teacherInfo.TeacherGetBlogReadCount({ id: id }).then((res) => {});
      this.$router.push({
        path: '/diaoa/blog',
        query: {
          id: id,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.teachingblot {
  width: 303px;
  min-height: 280px;
  box-sizing: border-box;
  padding: 19px 15px 0px 15px;

  .blottop {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 13px;

    &>div:nth-child(1) {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: #4D515A;
    }
    &>div:nth-child(2) {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: #4C515B;
      cursor: pointer;

      i{
        color: #A7B1BC;
      }
    }
  }

  .blota {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    &>div:nth-child(1) {
      flex-shrink: 0;
      min-width: 18px;
      height: 18px;
      background-color: transparent;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #768297;
      border-radius: 3px;
      margin-right: 7px;
    }

    .oneLable{
      background-color: #FFE8E3 !important;
      color: #FF7070 !important;
    }
    .twoLable{
      background-color: #FFEDD2 !important;
      color: #FF9255 !important;
    }
    .threeLable{
      background-color: #FFF4CC !important;
      color: #F4AD00 !important;
    }

    &>div:nth-child(2) {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      color: #31303F;

      &:hover{
        cursor: pointer;
        color: #1492ff !important;
      }
    }
    &>div:nth-child(3){
      flex-shrink: 0;
      margin-left: 10px;
      font-size: 400;
      font-size: 12px;
      line-height: 18px;
      color: #7D899D;
    }
  }
}

.noDataBox{
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #7D899D;
  font-size: 16px;
}

</style>